let baseURL = window.location.origin;
if (!baseURL) {
  baseURL =
    window.location.protocol +
    "//" +
    window.location.hostname +
    (window.location.port ? ":" + window.location.port : "");
}
export const apiUrl =
  process.env.NODE_ENV === "production"
    ? `${baseURL}/api/v1`
    : "http://majotech.getpreview.io/api/v1";
// export const apiUrl = process.env.NODE_ENV === 'production' ? `${baseURL}/api/v1` : 'http://majotech.getpreview.io/api/v1'



// WEBPACK FOOTER //
// ./constants/defaultValues.js